import type { ProductCardGridAttributes } from '../../types/cms'
import { Container, Grid } from '@mui/material'
import ProductCard from '../ProductCard'

const ProductCardGrid = ({
  product_cards: productCards,
}: ProductCardGridAttributes) => {
  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      <Grid container justifyContent="center" spacing={2} sx={{ mx: 'auto' }}>
        {productCards?.data?.map(
          ({
            attributes: {
              info,
              logo,
              productImage,
              button,
              brandNameType,
              brandName,
            } = {},
          }) => (
            <Grid item key={info} xs={12} sm={6} lg={4}>
              <ProductCard
                text={info}
                logo={logo}
                image={productImage}
                button={button}
                brandNameType={brandNameType}
                brandName={brandName}
              />
            </Grid>
          ),
        )}
      </Grid>
    </Container>
  )
}

export default ProductCardGrid
